var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChargeBattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7825 21.0864H5.15674C4.05217 21.0864 3.15674 20.1909 3.15674 19.0864V18.6952V10.0867V10.0867C3.15674 9.04561 4.00069 8.20166 5.04176 8.20166H18.958C19.9991 8.20166 20.843 9.04561 20.843 10.0867V10.0867V18.6952V19.0864C20.843 20.1909 19.9476 21.0864 18.843 21.0864H18.2173M5.7825 21.0864V22.4995C5.7825 22.7757 6.00636 22.9995 6.2825 22.9995H9.10859C9.38473 22.9995 9.60859 22.7757 9.60859 22.4995V21.0864M5.7825 21.0864H9.60859M9.60859 21.0864H14.3912M18.2173 21.0864V22.4995C18.2173 22.7757 17.9934 22.9995 17.7173 22.9995H14.8912C14.6151 22.9995 14.3912 22.7757 14.3912 22.4995V21.0864M18.2173 21.0864H14.3912",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 11L10 14.5H14L11.3333 18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53285 5.8638L6.53267 8H9L9.00018 5.8638M6.53285 5.8638H9.00018M6.53285 5.8638V5.8638C5.95644 5.84279 5.5 5.36942 5.5 4.79263V4.41322C5.5 3.7919 6.00368 3.28822 6.625 3.28822V3.28822M9.00018 5.8638V5.8638C9.55236 5.8638 10 5.41616 10 4.86397V4.41322C10 3.7919 9.49632 3.28822 8.875 3.28822V3.28822M6.625 3.28822V1.82622C6.625 1.27393 7.07272 0.826219 7.625 0.826219H7.875C8.42728 0.826219 8.875 1.27393 8.875 1.82622V3.28822M6.625 3.28822H8.875",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5002 5.8638L14.5 8H16.9673L16.9675 5.8638M14.5002 5.8638H16.9675M14.5002 5.8638V5.8638C13.9238 5.84279 13.4673 5.36942 13.4673 4.79263V4.41322C13.4673 3.7919 13.971 3.28822 14.5923 3.28822V3.28822M16.9675 5.8638V5.8638C17.5197 5.8638 17.9673 5.41616 17.9673 4.86397V4.41322C17.9673 3.7919 17.4636 3.28822 16.8423 3.28822V3.28822M14.5923 3.28822V1.82622C14.5923 1.27393 15.04 0.826219 15.5923 0.826219H15.8423C16.3946 0.826219 16.8423 1.27393 16.8423 1.82622V3.28822M14.5923 3.28822H16.8423",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeBattery);
export default __webpack_public_path__ + "static/media/charge-battery.c238ed98.svg";
export { ForwardRef as ReactComponent };